module.exports = __webpack_public_path__ + "119336fd51de2a0738e2be165a85079f.svg";